import websocketApi from './api';
import websocketToasts from './toasts';

export default [websocketApi(), websocketToasts()];
